import type { PropsWithChildren } from 'react';
import type React from 'react';

import { PaypalContext } from './context';
import { usePaypalState } from './usePaypalState';

export const PaypalProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const state = usePaypalState();

	return <PaypalContext.Provider value={state}>{children}</PaypalContext.Provider>;
};
